import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AboutusService } from 'src/services/aboutus.service';
@Component({
  selector: 'app-about-us-detail',
  templateUrl: './about-us-detail.component.html',
  styleUrls: ['./about-us-detail.component.scss'],
})
export class AboutUsDetailComponent implements OnInit {
  /**
   * Proerty Declaration
   */
  selectedPage: any;
  activeIndex: any;
  displayCustom: boolean;
  images: any = [];
  public aboutUsInfoData: any = { bannerImage: null, bannerTitle: null, content: null };
  bannerImage: any;

  /**
   * Constructor
   * @param route
   * @param aboutusService
   * @param router
   */
  constructor(private route: ActivatedRoute, private aboutusService: AboutusService, private router: Router) {}

  /**
   * ngOnInit Method
   */
  ngOnInit(): void {
    //fetching query params
    this.route.queryParams.subscribe((params) => {
      this.selectedPage = params['selectedPage'];
      this.getDetails();
    });
  }

  /**
   * GetDetails Method
   */
  getDetails() {
    //get deatils of selected page(fetched from query params)
    this.aboutusService.getAboutUsDetails(this.selectedPage).subscribe((aboutUsInfo) => {
      if (aboutUsInfo) {
        this.aboutUsInfoData = aboutUsInfo;
        if (aboutUsInfo.bannerImage) {
          this.bannerImage = aboutUsInfo.bannerImage;
        } else {
          this.bannerImage = '../../../assets/images/NoImage.jpg';
        }
      }
    });
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
